import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSoundOff = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("g", {
		stroke: "none",
		strokeWidth: 1,
		fill: "var(--main-color)",
		fillRule: "evenodd",
		children: /* @__PURE__ */ _jsxs("g", {
			fillRule: "nonzero",
			children: [/* @__PURE__ */ _jsx("path", { d: "M4.71 3.29a1.004 1.004 0 10-1.42 1.42l16 16a1 1 0 001.42 0 1 1 0 000-1.42l-16-16zM16.91 14.08l1.44 1.44a6 6 0 00-.07-7.15 1.003 1.003 0 10-1.56 1.26 4 4 0 01.19 4.45z" }), /* @__PURE__ */ _jsx("path", { d: "M21 12a6.51 6.51 0 01-1.78 4.39l1.42 1.42A8.53 8.53 0 0023 12a8.75 8.75 0 00-3.36-6.77 1.001 1.001 0 10-1.28 1.54A6.8 6.8 0 0121 12zM13.5 18.1l-5.1-3.5a1 1 0 00-.57-.17H3.5V9.57h3.24l-2-2H2.5a1 1 0 00-1 1v6.86a1 1 0 001 1h5l6.41 4.4c.17.11.368.169.57.17a1 1 0 001-1v-1.67l-2-2 .02 1.77zM13.5 5.9v4.77l2 2V4a1 1 0 00-1.57-.83L9.23 6.4l1.44 1.44L13.5 5.9z" })]
		})
	})
});
export { SvgSoundOff as ReactComponent };
